import {Card, Col, Flex, Row, Tooltip, Typography, Image} from "antd"
import {useTranslations} from "next-intl";
import React from "react";

import Icon from "@ant-design/icons";
import {ThemeColors} from "@/src/entities/colors";

const { Link } = Typography;

const OrganizationsComponent = () => {
    const getLogos = () => {
        return [
            {image: "/assets/logos/europe.jpg"},
            {image: "/assets/logos/levante.png"},
            {image: "/assets/logos/apulia_promo.jpg"},
            {image: "/assets/logos/leader.png"},
            {image: "/assets/logos/psr.png"},
            {image: "/assets/logos/apulia_region.jpg"}
        ]
    }

    return (
        <div style={{backgroundColor: "#eee", paddingBottom: 40, paddingTop: 40}}>
            <Row gutter={[16, { xs: 24, sm: 24, md: 24, lg: 32 }]} style={{textAlign: "center", margin: "0 8px"}}>
                {(() => {
                    return getLogos().map((value, index) => {
                        return (
                            <Col xs={12} sm={8} md={8} lg={4} key={index}>

                                    <Image preview={false} src={value.image} style={{height: 120}}/>

                            </Col>
                        )
                    })
                })()}
            </Row>
        </div>

    )
}

export default OrganizationsComponent